﻿import {Injectable} from '@angular/core';
import { AuthService } from '../common/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoginService {
    constructor(private authService: AuthService) { }

    get isLoggedIn() {
        if (this.authService.isLoggedIn) {
            return true;
        }
        return false;
    }

    login(userID: string, password: string, institution) {
        return this.authService.login(userID, password, institution);
    }

    get logoutMessage() {
        return this.authService.logoutMessage;
    }

    set defaultLogoutMessage(message: any) {
        this.authService.logoutMessage = message;
    }
}